import React, { useEffect, useState } from 'react'

import { logErrorAsync } from '_lib/utility'
import { getDestinations } from '_services/destinations'

const useDestinations = () => {
  const [destinations, setDestinations] = useState([])

  useEffect(() => {
    async function getData() {
      try {
        const destinationsResponse = await getDestinations({
          fields: ['_id', 'name', 'slug'],
          limit: 1000,
        })

        setDestinations(destinationsResponse.items.sort((a, b) => (a.name > b.name ? 1 : -1)))
      } catch (error) {
        logErrorAsync(error)
        toast.error(error.message)
      }
    }
    getData()
  }, [])

  return destinations
}

export default useDestinations
